export const money = (
  amount: number | string,
  options?: Omit<Intl.NumberFormatOptions, 'style'>
): string => {
  return new Intl.NumberFormat('de', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    ...options
  }).format(+amount);
};
